import React from 'react';
import { Languages } from '../../components/languages';
import { Roles } from '../../auth/rolesPermissions';
import { UIFilterPanel, PageTitle, UIInput, UIButton, UICheckbox, UISelect, UITableWithPagination, UIInputGroup } from '../../components/guiElements';
import { getStockAPI } from "../../api/warehouseAPI";
import { warehouseUIProfiles } from '../../auth/warehouseProfiles';

export default class WarehouseStock extends React.Component {
    constructor(props) {
        super(props);
        this.getDataStock = this.getDataStock.bind(this);
        this.buildEntriesStock = this.buildEntriesStock.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleFilterSearch = this.handleFilterSearch.bind(this);

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.uiProfile = warehouseUIProfiles[this.uc?.userRole] || warehouseUIProfiles.DEFAULT;
        this.le = Languages.Warehouse.Stock[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this._isMounted = false;

        this.configs = {
            filters: this.getFiltersConfig(),
        };

        this.header = this.getStockHeaders();
        const filters = this.createInitialFilters();
        this.appliedFilters = filters;

        this.state = {
            entries: [],
            filters: filters,
            products: [],
            totals: [],
            loading: false,
            advancedOpen: false,

            pageNumber: 1, //pagina corrente
            pageSize: 10, //numero di elementi per pagina
            sortField: "SKU", // campo per cui i dati vengono ordinati
            sortDirection: "asc", //asc/desc

            totalItems: 0, //numero totale di record trovati,
            totalPages: 0 //Numero torale di pagine
        };

    }

    //#region Configuration Builders

    getStockHeaders() {

        const headers = [
            { label: this.le.list.captions[0], field: "SKU", className: "cell-center" },
            { label: this.le.list.captions[1], field: "description", className: "cell-description" },
            { label: this.le.list.captions[2], field: "avaibleQuantity", className: "cell-center" },
            { label: this.le.list.captions[3], field: "reservedQuantity", className: "cell-center" },
            { label: this.le.list.captions[4], field: "serialCode", className: "cell-center" },
            { label: this.le.list.captions[5], field: "SORD", className: "cell-center" }, 
            { label: this.le.list.captions[6], field: "BCNU", className: "cell-center" },
            { label: this.le.list.captions[7], field: "SCNU", className: "cell-center" },
            { label: this.le.list.captions[8], field: "ownerCode", className: "cell-center" },
            { label: this.le.list.captions[9], field: "CNUM", className: "cell-center", size: 2 },
        ]

        if (this.uiProfile.showDealerColumn) {
            headers.push(
                {
                    label: this.le.list.captions[10],
                    field: "dealerName",
                    className: "cell-center"
                },
                {
                    label: this.le.list.captions[11],
                    field: "dealerCode",
                    className: "cell-center"
                }
            );
        }

        return headers;

    }

    getFiltersConfig() {
        const filters = {
            SKU: { type: "text", width: "20%" },
            description: { type: "text", width: "20%" },
            DELN: { type: "text", width: "20%" },
            SORD: { type: "text", width: "20%" },
            ...(this.uiProfile.showDealerColumn && {
                dealerCode: {
                    type: "text",
                    width: "20%"
                }
            }),
            SCNU: { type: "text", width: "20%" },
            SCNA: { type: "text", width: "20%" },
            CNUM: { type: "text", width: "20%" },
            serialCode: { type: "text", width: "20%" },

            QuantityFilter: {
                type: "inputGroup",
                width: "25%",
                options: [
                    { text: "...", value: "" },
                    { text: "=", value: "=" },
                    { text: ">", value: ">" },
                    { text: "<", value: "<" }
                ]
            },
        };

        filters.filterButton = { type: "button" };
        filters.clearButton = { type: "clearButton" };

        return filters;
    }

    createInitialFilters() {
        const filters = {};

        Object.keys(this.configs.filters).forEach(key => {
            if (key === "QuantityFilter") {
                filters[key] = {
                    Comparison: "",
                    Value: ""
                };
            } else {
                filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
            }
        });

        return filters;
    }

    //#endregion

    componentDidMount() {
        const { filters } = this.state;
        this._isMounted = true;
        this.getDataStock(filters);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    //#region Data functions

    //#region Get Stock Data

    parseSKUFilter(skuValue) {
        return (skuValue || "").split(";").map(sku => sku.trim()).filter(Boolean);
    }

    getDataStock = async (filters) => {
        if (this._isMounted) {
            this.setState({ loading: true })
        }

        const { pageNumber, pageSize, sortField, sortDirection } = this.state;

         try {
             const skuList = this.parseSKUFilter(filters.SKU);
             const dealerCode =
                 this.uc.userRole === Roles.WAREHOUSEUSER
                     ? this.uc.dealerCode
                     : (filters.dealerCode || null);

             const getStockData = {
                 Data: {
                     SKU: skuList,
                     dealerCode: dealerCode,
                     lot: filters.serialCode || null,
                     description: filters.description || "",
                     state: "BUONO",
                     SORD: filters.SORD || null,
                     DELN: filters.DELN || null,
                     SCNU: filters.SCNU || null,
                     SCNA: filters.SCNA || null,
                     CNUM: filters.CNUM || null,
                     
                     warehouseLabelCode: null,
                     language: Languages.selectedLanguage.toUpperCase(),
                     PageNumber: pageNumber,
                     PageSize: pageSize,
                     SortField: sortField,
                     SortDirection: sortDirection
                }
             };

             const quantityComparison = filters.QuantityFilter?.Comparison;
             const quantityValue = filters.QuantityFilter?.Value;

             const hasQuantityComparison =
                 quantityComparison !== null &&
                 quantityComparison !== undefined &&
                 quantityComparison !== "";

             const hasQuantityValue =
                 quantityValue !== null &&
                 quantityValue !== undefined &&
                 quantityValue !== "";

             if (hasQuantityComparison && hasQuantityValue) {
                 const parsedQuantityValue = parseInt(quantityValue, 10);

                 getStockData.Data.QuantityFilter = {
                     Comparison: quantityComparison,
                     Value: Number.isNaN(parsedQuantityValue)
                         ? null
                         : parsedQuantityValue
                 };
             } else {
                 getStockData.Data.QuantityFilter = null;
             }
                 
            this.props.loaderShow(0);
            const response = await getStockAPI(this.uc.jwtToken, getStockData);
            
                if (response.error == null) {
                    this.props.loaderHide();
                    const stock = response?.result?.stock;
                    const products = stock?.data ?? [];
                    let entries = this.buildEntriesStock(products);

                    let totals = [{ name: 'stock', val: response.result.stock.data.length }];

                    if (this._isMounted) {
                        this.setState({
                            entries: entries,
                            products: response.result.stock.data,
                            totals: totals,
                            loading: false,
                            pageNumber: stock?.pageNumber ?? pageNumber,
                            pageSize: stock?.pageSize ?? pageSize,
                            totalItems: stock?.totalItems ?? products.length,
                            totalPages: stock?.totalPages ?? 1
                        });
                    }

                } else {
                    this.props.loaderHide();
                    this.props.popupErrorMessage(response.error.message);
                }
            
        }
         catch (e) {
            this.props.loaderHide();
            if (this._isMounted) {
                this.setState({loading: false})
            }
        }
    }

    getStockEntryId = (product) => {
        if (product.id !== null && product.id !== undefined) {
            return String(product.id);
        }

        return [
            product.dealerCode || "",
            product.sku || "",
            product.lot || "",
            product.sord || "",
            product.sscc || "",
            product.ownerCode || ""
        ].join("|");
    };

    buildEntriesStock = (products) => {
        let entries = [];

        for (let i = 0; i < products.length; i++) {
            let product = products[i];

            let entry = {
                id: this.getStockEntryId(product),
                SKU: product.sku,
                description: product.description,
                avaibleQuantity: product.availableQuantity?.toString() || "0",
                reservedQuantity: product.reservedQuantity?.toString() || "0",
                serialCode: product.lot ?? "",

                dealerName: product.dealerName ?? "",
                dealerCode: product.dealerCode ?? "",
                SORD: product.sord ?? "",
                SendLabel: product.sendLabel,
                ownerCode: product.ownerCode ?? "",
                BCNU: product.bcnu ?? "",
                SCNU: product.scnu ?? "",
                CNUM: product.cnum ?? "",
                SSCC: product.sscc ?? "",

                weight: product.weight ?? "0",
                volume: product.volume ?? "0",
                unitPrice: product.unitPrice ?? "0",
                originalPrice: product.originalPrice ?? "0",
                discount: product.discount ?? "0",
                voucher: product.voucher ?? "0",
                annotations: product.annotations ?? ""
            };

            entries.push(entry);
        }

        return entries;
    };

    // #endregion Get Stock Data

    handleClearFilters = () => {
        const filters = this.createInitialFilters();

        this.setState(
            {
                filters,
                pageNumber: 1
            },
            () => {
                this.getDataStock(filters);
            }
        );
    };

    handleFilterSearch = (ev) => {
        ev.preventDefault();

        this.setState(
            { pageNumber: 1 },
            () => this.getDataStock(this.state.filters)
        );
    }

    handleFilterChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "QuantityFilter.Comparison" || name === "QuantityFilter.Value") {
            const field = name.split(".")[1];

            return this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    QuantityFilter: {
                        ...prevState.filters.QuantityFilter,
                        [field]: value
                    }
                }
            }));
        }

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: type === "checkbox" ? checked : value
            }
        }));
    };

    handlePageChange = (pageNumber) => {
        this.setState(
            { pageNumber },
            () => this.getDataStock(this.state.filters)
        );
    }

    handlePageSizeChange = (pageSize) => {
        this.setState(
            {
                pageSize,
                pageNumber: 1
            },
            () => this.getDataStock(this.state.filters)
        );
    }

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            advancedOpen: !prevState.advancedOpen
        }));
    };
    
    //#endregion Data functions

    render() {
        let filters = {};

        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);

        const advancedFilters = ["DELN", "SORD", "dealerCode", "SCNU", "SCNA", "CNUM", "serialCode"];

        const mainFilterKeys = Object.keys(filters).filter(key =>
            !advancedFilters.includes(key)
        );

        const advancedFilterKeys = this.state.advancedOpen
            ? advancedFilters
            : [];

        let pageFilters = Object.entries(filters).map(([key, val]) => {
            switch (val.type) {
                case "select":
                    return <UISelect key={key} filterKey={key} name={key} options={val.options} value={val.value} onChange={this.handleFilterChange} />;
                case "checkbox":
                    return <UICheckbox key={key} filterKey={key} name={key} onChange={this.handleFilterChange} value={val.value} label={this.le.filters.items[key]} />;
                case "inputGroup":
                    return <UIInputGroup
                        key={key}
                        filterKey={key}
                        className="stock-quantity-filter"
                        leftName="QuantityFilter.Comparison"
                        leftValue={this.state.filters.QuantityFilter.Comparison}
                        leftOptions={val.options}
                        rightType="number"
                        rightName="QuantityFilter.Value"
                        rightValue={this.state.filters.QuantityFilter.Value}
                        hint={this.le.filters.items.QuantityFilter}
                        onChange={this.handleFilterChange}
                    />
                case "button":
                    return <UIButton key={key} filterKey={key} text={this.le.filters.items[key]} onClick={(ev) => this.handleFilterSearch(ev)} className="filter-button" />;
                case "clearButton":
                    return (
                        <UIButton
                            key={key}
                            filterKey={key}
                            text={this.le.filters.items[key]}
                            onClick={this.handleClearFilters}
                            className="filter-button secondary"
                        />
                    );
                default:
                    return <UIInput key={key} filterKey={key} type={val.type} name={key} maxDate={new Date()} onChange={this.handleFilterChange} value={val.value} hint={this.le.filters.items[key]} />;
            }
        }, this);

        return <div className="page-storaging">
            <PageTitle icon="../images/mainMenu/Giacenze.png" title={Languages.getSection('Main').menuLabels.stock} />
            <div className="page-content">

                <UIFilterPanel
                    className=" no-last filter-panel-advanced"
                    advancedOpen={this.state.advancedOpen}
                    onAdvancedToggle={this.toggleAdvancedFilters}
                    advancedContent={pageFilters.filter(el =>
                        advancedFilterKeys.includes(el.props.filterKey)
                    )}
                >
                    {pageFilters.filter(el =>
                        mainFilterKeys.includes(el.props.filterKey)
                    )}
                </UIFilterPanel>

                <div className="readonly-table-safe-area">
                    <UITableWithPagination
                        headers={this.header}
                        items={this.state.entries}
                        rowKey="id" 
                        serverSidePagination={true}
                        currentPage={this.state.pageNumber}
                        itemsPerPage={this.state.pageSize}
                        totalItems={this.state.totalItems}
                        totalPages={this.state.totalPages}
                        onPageChange={this.handlePageChange}
                        onItemsPerPageChange={this.handlePageSizeChange}
                    />
                </div>

            </div>
        </div>;
    }
}